var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    stroke: "#D8D8D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 32c0 14.36-11.64 26-26 26C17.642 58 6 46.36 6 32S17.641 6 32 6c14.36 0 26 11.64 26 26z",
    fill: "#58B847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.84 35.295l10.422-10.808a1.564 1.564 0 012.268 0c.627.65.627 1.703 0 2.353L29.84 40l-7.37-7.644a1.708 1.708 0 010-2.352 1.564 1.564 0 012.268 0l5.102 5.29z",
    fill: "#fff"
  })));
}
export default SvgGreenCheckCircle;